var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPasswordIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 0C18.3137 0 21 2.68629 21 6V9H23.625C25.489 9 27 10.511 27 12.375V26.625C27 28.489 25.489 30 23.625 30H6.375C4.51104 30 3 28.489 3 26.625V12.375C3 10.511 4.51104 9 6.375 9H9V6C9 2.68629 11.6863 0 15 0ZM23.625 11.25H6.375C5.75368 11.25 5.25 11.7537 5.25 12.375V26.625C5.25 27.2463 5.75368 27.75 6.375 27.75H23.625C24.2463 27.75 24.75 27.2463 24.75 26.625V12.375C24.75 11.7537 24.2463 11.25 23.625 11.25ZM15.0002 17.25C16.2428 17.25 17.2502 18.2574 17.2502 19.5C17.2502 20.7426 16.2428 21.75 15.0002 21.75C13.7575 21.75 12.7502 20.7426 12.7502 19.5C12.7502 18.2574 13.7575 17.25 15.0002 17.25ZM15 2.25C12.9289 2.25 11.25 3.92893 11.25 6V9H18.75V6C18.75 3.92893 17.0711 2.25 15 2.25Z",
    fill: "#3D3839",
    fillOpacity: 0.7
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordIcon);
export default __webpack_public_path__ + "static/media/password_icon.cbd582a8a85ec585940478ab4ed3d063.svg";
export { ForwardRef as ReactComponent };